import { render, staticRenderFns } from "./full-validation-info.vue?vue&type=template&id=18a4cc7c&scoped=true"
import script from "./full-validation-info.vue?vue&type=script&lang=js"
export * from "./full-validation-info.vue?vue&type=script&lang=js"
import style0 from "./full-validation-info.vue?vue&type=style&index=0&id=18a4cc7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4cc7c",
  null
  
)

export default component.exports